import { themeQuartz } from 'ag-grid-community';

import { BlackHeadings } from 'src/theme/colors';

// Portal grid theme — JS Theming API replacement for the legacy
// `.ag-theme-portal` CSS variant.
//
// Borders, row/header heights, and cell padding are deliberately left
// to the consuming component's `.ag-theme-portal` overrides (e.g. the
// makeStyles block in `DataTable`); this theme only sets the color +
// typography tokens that don't collide with those overrides.
export const portalTheme = themeQuartz.withParams({
  // Colors
  foregroundColor: BlackHeadings,
  backgroundColor: '#ffffff',
  headerBackgroundColor: '#ffffff',
  headerTextColor: 'rgba(17, 51, 83, 0.7)',
  borderColor: '#f8fafb',
  rowHoverColor: '#f8fafb',
  selectedRowBackgroundColor: '#eeeeee',
  oddRowBackgroundColor: '#ffffff',

  // Typography
  fontFamily: 'inherit',
  fontSize: 13,
  headerFontSize: 13,
  headerFontWeight: 400,

  // Borders: the header row border is managed by the theme (not SCSS) so
  // that ag-grid accounts for it in its internal height calculation.
  // Keeping it in SCSS caused the header to render 1px shorter than v27
  // (v35 includes the border in the element's height, while v27 added it
  // on top). All other borders are left to SCSS.
  borderRadius: 0,
  wrapperBorder: false,
  headerRowBorder: '1px solid #eff1f4',
  rowBorder: false,
  columnBorder: false,
  headerColumnBorder: false,
  // v27 had no pinned-column separator line. Quartz derives this from
  // borderColor (#f8fafb) which shows as a faint 1px line between pinned
  // and center columns. Suppress it to match v27 behavior.
  pinnedColumnBorder: false,

  // v27 didn't render a visible column-resize handle; Quartz draws a
  // 2px-wide bar in the border color at each header column boundary
  // which looks like a stray vertical line. Hide it to keep parity.
  headerColumnResizeHandleColor: 'transparent',
});
